$(document).ready(function()
{


    /*$('.slick-advert.has-zoom').on('init', function() 
    {
      $('.slick-advert.has-zoom .slick-slide[data-slick-index="0"]').addClass('zoom-m40');
    })

    if ( $('.no-slick.has-zoom').length )
    {
      $('.no-slick.has-zoom').addClass('zoom-m40');
    }

    // On before slide change
    $('.slick-advert.has-zoom').on('beforeChange', function(event, { slideCount: count }, currentSlide, nextSlide)
    {
          let selectors = [nextSlide, nextSlide - count, nextSlide + count].map(n => `[data-slick-index="${n}"]`).join(', ');
          //console.log(selectors);
          $('.slick-advert.has-zoom .zoom-m40').removeClass('zoom-m40');
          $(selectors).addClass('zoom-m40');

    });


    $('.slick-story.has-zoom').on('init', function() 
    {
      $('.slick-story.has-zoom .slick-slide[data-slick-index="0"]').addClass('zoom-m40');
    })

    if ( $('.no-slick.has-zoom').length )
    {
      $('.no-slick.has-zoom').addClass('zoom-m40');
    }

    // On before slide change
    $('.slick-story.has-zoom').on('beforeChange', function(event, { slideCount: count }, currentSlide, nextSlide)
    {
          let selectors = [nextSlide, nextSlide - count, nextSlide + count].map(n => `[data-slick-index="${n}"]`).join(', ');
          //console.log(selectors);
          $('.slick-story.has-zoom .zoom-m40').removeClass('zoom-m40');
          $(selectors).addClass('zoom-m40');

    });*/

});
